import React from "react";
import Pagination$ from "@deosite/components-new/Pagination";
import ButtonMinimalIcon from "@deosite/components-new/buttons/ButtonMinimalIcon";
import QuantityPickerSmall from "../quantityPickers/QuantityPickerSmall";

const Pagination = props => {
  const propsExt = {
    ...props,
    qtyPicker: <QuantityPickerSmall />
  };
  return (
    <Pagination$
      {...propsExt}
      prevButton={<ButtonMinimalIcon />}
      nextButton={<ButtonMinimalIcon />}
    />
  );
};

export default Pagination;
